(function () {
  'use strict';

  var ROOT_ID = 'dcpowderpdp';
  var activeCard = null;
  var activeDetail = null;
  var PHONE_HREF = '+14056170717';
  var PHONE_LABEL = '(405) 617-0717';
  var DOSES = [1, 3, 5, 7];
  var CY_NOTE_STYLE = 'grid-column:1/-1;display:none;margin:.2rem 0 0;padding:.9rem 1.1rem;border:1px solid var(--dcpw-border,#cbd7e8);border-left:3px solid var(--dcpw-navy,#103b78);border-radius:.6rem;background:var(--dcpw-panel,#f4f8fd);color:var(--dcpw-muted,#5d6675);font-size:1.25rem;line-height:1.45';

  var UNITS = {
    sack94: { label: '94 lb cement sacks', binderLb: 94, short: '94 lb sacks' },
    bag50: { label: '50 lb overlay bags', binderLb: 50, short: '50 lb overlay bags' },
    cy: { label: 'Cubic yards · 5-sack mix', binderLb: 470, short: 'cubic yards' }
  };

  function escapeHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function money(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function roundOne(value) {
    return Math.round(value * 10) / 10;
  }

  function cards(root) {
    return Array.prototype.slice.call(root.querySelectorAll('#dcpowderGrid > .dcpw-card'));
  }

  function cardCode(card) {
    return card ? String(card.getAttribute('data-code') || '') : '';
  }

  function cardName(card) {
    return card ? String(card.getAttribute('data-name') || '') : '';
  }

  function cardImage(card) {
    return card ? String(card.getAttribute('data-image') || '') : '';
  }

  function detailFor(root, card) {
    var id = card && card.getAttribute('aria-controls');
    return id ? root.querySelector('#' + id) : null;
  }

  function columnCount(grid) {
    var template = window.getComputedStyle(grid).gridTemplateColumns || '';
    var columns = template.trim().split(/\s+/).filter(Boolean).length;
    return Math.max(1, columns || 1);
  }

  function placeDetail(grid, card, detail) {
    if (!grid || !card || !detail) return;
    var allCards = Array.prototype.slice.call(grid.querySelectorAll(':scope > .dcpw-card'))
      .filter(function (item) { return !item.hidden; });
    var index = allCards.indexOf(card);
    if (index < 0) return;
    var columns = columnCount(grid);
    var rowEnd = Math.min(allCards.length - 1, Math.ceil((index + 1) / columns) * columns - 1);
    var anchor = allCards[rowEnd];
    grid.insertBefore(detail, anchor.nextSibling);
  }

  function closeDetail(restoreFocus) {
    if (!activeCard || !activeDetail) return;
    activeCard.classList.remove('is-selected');
    activeCard.setAttribute('aria-expanded', 'false');
    activeDetail.hidden = true;
    if (restoreFocus) activeCard.focus();
    activeCard = null;
    activeDetail = null;
  }

  function applyFamilyFilter(root, family) {
    var selected = family || 'all';
    var familyButtons = Array.prototype.slice.call(root.querySelectorAll('.dcpw-filter [data-powder-family]'));
    var known = familyButtons.some(function (button) {
      return button.getAttribute('data-powder-family') === selected;
    });
    if (!known) selected = 'all';

    closeDetail(false);
    cards(root).forEach(function (card) {
      var visible = selected === 'all' || card.getAttribute('data-family') === selected;
      card.hidden = !visible;
      card.setAttribute('aria-expanded', 'false');
      card.classList.remove('is-selected');
      var detail = detailFor(root, card);
      if (detail) detail.hidden = true;
    });
    familyButtons.forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.getAttribute('data-powder-family') === selected));
    });
  }

  function openDetail(root, card, scrollIntoView, keepOpen) {
    if (card && card.hidden) {
      applyFamilyFilter(root, card.getAttribute('data-family') || 'all');
    }
    var detail = detailFor(root, card);
    var grid = root.querySelector('#dcpowderGrid');
    if (!detail || !grid) return;
    if (activeCard === card && activeDetail === detail && !detail.hidden) {
      if (keepOpen && scrollIntoView) detail.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (keepOpen) return;
      closeDetail(true);
      return;
    }
    closeDetail(false);
    placeDetail(grid, card, detail);
    detail.hidden = false;
    card.classList.add('is-selected');
    card.setAttribute('aria-expanded', 'true');
    activeCard = card;
    activeDetail = detail;

    var form = detail.querySelector('form.dcpw-buy');
    var badge = detail.querySelector('[data-detail-stock]');
    if (badge) {
      var available = form && parseInt(form.getAttribute('data-available-count'), 10) > 0;
      badge.textContent = available ? 'In stock' : 'Unavailable';
      badge.classList.toggle('is-unavailable', !available);
    }
    if (window.DcPowderBuy) window.DcPowderBuy.init(detail);
    if (scrollIntoView && window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches) {
      window.requestAnimationFrame(function () {
        detail.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function variantsFor(root, code) {
    var detail = root.querySelector('#dcpwd' + code);
    if (!detail) return [];
    return Array.prototype.slice.call(detail.querySelectorAll('form.dcpw-buy input[name="id"]:not(:disabled)'))
      .map(function (radio) {
        return {
          id: parseInt(radio.value, 10),
          lb: parseInt(radio.getAttribute('data-size-lb'), 10),
          price: parseInt(radio.getAttribute('data-price-cents'), 10),
          label: radio.getAttribute('data-size-label') || ''
        };
      })
      .filter(function (variant) {
        return variant.id > 0 && [1, 5, 10, 25].indexOf(variant.lb) >= 0;
      });
  }

  /* Cheapest in-stock combination that covers the estimate without supplying
     more than twice the calculated need; fewest bags breaks price ties. */
  function bestMatch(needed, variants) {
    if (!(needed > 0) || !variants.length) return { kind: 'none', picks: [] };
    var smallest = Math.min.apply(null, variants.map(function (item) { return item.lb; }));
    if (needed < smallest) return { kind: 'sample', picks: [], smallest: smallest };
    var floor = Math.ceil(needed - 1e-9);
    var largest = Math.max.apply(null, variants.map(function (item) { return item.lb; }));
    var limit = floor + largest;
    var dp = new Array(limit + 1);
    dp[0] = { bags: 0, price: 0, use: {} };

    for (var total = 1; total <= limit; total += 1) {
      var winner = null;
      for (var index = 0; index < variants.length; index += 1) {
        var variant = variants[index];
        if (variant.lb > total || !dp[total - variant.lb]) continue;
        var previous = dp[total - variant.lb];
        var candidate = {
          bags: previous.bags + 1,
          price: previous.price + variant.price,
          previous: total - variant.lb,
          variant: variant
        };
        if (!winner || candidate.bags < winner.bags ||
          (candidate.bags === winner.bags && candidate.price < winner.price)) winner = candidate;
      }
      if (winner) {
        var use = {};
        Object.keys(dp[winner.previous].use).forEach(function (key) { use[key] = dp[winner.previous].use[key]; });
        use[winner.variant.lb] = (use[winner.variant.lb] || 0) + 1;
        dp[total] = { bags: winner.bags, price: winner.price, use: use };
      }
    }

    var match = null;
    var supplied = 0;
    var cap = needed * 2;
    for (var candidateTotal = floor; candidateTotal <= limit; candidateTotal += 1) {
      var candidateMatch = dp[candidateTotal];
      if (!candidateMatch || candidateTotal > cap) continue;
      if (!match || candidateMatch.price < match.price ||
        (candidateMatch.price === match.price && candidateMatch.bags < match.bags)) {
        match = candidateMatch;
        supplied = candidateTotal;
      }
    }
    if (!match) {
      for (var fallback = floor; fallback <= limit; fallback += 1) {
        if (dp[fallback]) { match = dp[fallback]; supplied = fallback; break; }
      }
    }
    if (!match) return { kind: 'none', picks: [] };

    var bySize = {};
    variants.forEach(function (variant) { bySize[variant.lb] = variant; });
    var picks = Object.keys(match.use).map(Number).sort(function (a, b) { return b - a; })
      .map(function (lb) {
        return { id: bySize[lb].id, lb: lb, quantity: match.use[lb], price: bySize[lb].price };
      });
    return {
      kind: 'buy',
      picks: picks,
      bags: match.bags,
      supplied: supplied,
      totalPrice: match.price
    };
  }

  function calculatorMarkup(allCards) {
    var colorOptions = allCards.map(function (card) {
      return '<option value="' + escapeHTML(cardCode(card)) + '">' +
        escapeHTML(cardName(card)) + ' · Code ' + escapeHTML(cardCode(card)) + '</option>';
    }).join('');
    var doseOptions = DOSES.map(function (dose) {
      return '<option value="' + dose + '">' + dose + ' lb per 94 lb cement sack</option>';
    }).join('');
    var unitOptions = Object.keys(UNITS).map(function (key) {
      return '<option value="' + key + '">' + escapeHTML(UNITS[key].label) + '</option>';
    }).join('');

    return '<header class="dcpw-calculator__head">' +
      '<span class="dcpw-calculator__icon" aria-hidden="true">▦</span>' +
      '<div><h2>How much pigment powder do you need?</h2>' +
      '<p>Choose a raw pigment code, loading rate, and project size.</p></div></header>' +
      '<div class="dcpw-calculator__body">' +
        '<div class="dcpw-calculator__fields">' +
          '<label><span>Pigment color</span><select data-calc-color>' + colorOptions + '</select></label>' +
          '<label><span>Loading rate</span><select data-calc-dose>' + doseOptions + '</select></label>' +
          '<label><span>Project size</span><span class="dcpw-calculator__project">' +
            '<button type="button" data-project-minus aria-label="Decrease project size">−</button>' +
            '<input type="number" min="0.5" step="0.5" value="5" inputmode="decimal" data-calc-amount>' +
            '<button type="button" data-project-plus aria-label="Increase project size">+</button>' +
          '</span></label>' +
          '<label><span>Project unit</span><select data-calc-unit>' + unitOptions + '</select></label>' +
          /* Shown only while the cubic-yard unit is selected. The yardage maths uses
             binderLb 470 — a five-sack yard, i.e. a 3,000 psi mix. A richer mix carries
             more cement per yard and needs more pigment for the same shade. Stated where
             the unit is chosen, hidden for the sack and overlay units.
             Styled inline against the --dcpw-* tokens so this needs no stylesheet change;
             the class is there if it should move into dc-powder-pdp.css later. Visibility
             is driven by display, not the hidden attribute, because the surrounding grid
             would otherwise override [hidden]. */
          '<p class="dcpw-calculator__cynote" data-calc-cynote style="' + CY_NOTE_STYLE + '">' +
            'Cubic yards are a 5 sack mix at 3,000 psi. For other psi or mix designs ' +
            '<a href="/pages/contact" style="color:var(--dcpw-navy,#103b78);font-weight:700">contact us</a>' +
            ' for loading dosage.</p>' +
        '</div>' +
        '<aside class="dcpw-calculator__result" data-calc-result></aside>' +
      '</div>' +
      '<footer class="dcpw-calculator__foot"><span>Estimate only; confirm the loading rate with a cured test panel before the full project.</span>' +
      '<a href="tel:' + PHONE_HREF + '">Need help? Call Pro Line · ' + PHONE_LABEL + '</a></footer>';
  }

  function installCalculator(root) {
    var grid = root.querySelector('#dcpowderGrid');
    var allCards = cards(root);
    if (!grid || !allCards.length) return;
    var calculator = root.querySelector('#dcPowderPdpCalc');
    if (!calculator) {
      calculator = document.createElement('section');
      calculator.id = 'dcPowderPdpCalc';
      calculator.className = 'dcpw-calculator';
      grid.insertAdjacentElement('afterend', calculator);
    }
    if (calculator.getAttribute('data-dcpw-wired') === 'true') return;
    calculator.setAttribute('data-dcpw-wired', 'true');
    calculator.innerHTML = calculatorMarkup(allCards);

    var color = calculator.querySelector('[data-calc-color]');
    var dose = calculator.querySelector('[data-calc-dose]');
    var amount = calculator.querySelector('[data-calc-amount]');
    var unit = calculator.querySelector('[data-calc-unit]');
    var result = calculator.querySelector('[data-calc-result]');
    var cyNote = calculator.querySelector('[data-calc-cynote]');

    function selectedCard() {
      return allCards.filter(function (card) { return cardCode(card) === color.value; })[0] || allCards[0];
    }

    function calculate() {
      var card = selectedCard();
      var code = cardCode(card);
      var name = cardName(card);
      var doseValue = parseFloat(dose.value) || 1;
      var project = Math.max(0, parseFloat(amount.value) || 0);
      var selectedUnit = UNITS[unit.value] || UNITS.sack94;
      if (cyNote) cyNote.style.display = (unit.value === 'cy') ? 'block' : 'none';
      var needed = roundOne(project * selectedUnit.binderLb / 94 * doseValue);
      var match = bestMatch(needed, variantsFor(root, code));
      var packCopy = '';
      var cartItems = [];

      if (match.kind === 'buy') {
        packCopy = match.picks.map(function (pick) {
          return pick.quantity + ' × ' + pick.lb + ' lb';
        }).join(' + ');
        cartItems = match.picks.map(function (pick) {
          return { id: pick.id, quantity: pick.quantity };
        });
      } else if (match.kind === 'sample') {
        packCopy = 'Less than the smallest available bag';
      } else {
        packCopy = 'No available bag sizes';
      }

      var formula = project + ' ' + selectedUnit.short + ' × ' + doseValue + ' lb per 94 lb sack';
      var action = match.kind === 'buy'
        ? '<button class="dcpw-calculator__atc" type="button" data-calc-add>Add to cart · ' + money(match.totalPrice) + '</button>'
        : '<button class="dcpw-calculator__atc" type="button" disabled>Review available options</button>';

      result.innerHTML = '<div class="dcpw-calculator__color"><img src="' + escapeHTML(cardImage(card)) + '" alt=""><div><b>' +
        escapeHTML(name) + '</b><span>Raw pigment · Code ' + escapeHTML(code) + '</span></div></div>' +
        '<div class="dcpw-calculator__need"><small>You need about</small><strong>' + needed + ' lb pigment</strong><span>' + escapeHTML(formula) + '</span></div>' +
        '<div class="dcpw-calculator__packs"><small>Recommended bags</small><b>' + escapeHTML(packCopy) + '</b>' +
        (match.kind === 'buy' ? '<span>' + match.supplied + ' lb supplied · ' + match.bags + ' bag' + (match.bags === 1 ? '' : 's') + '</span>' : '') + '</div>' +
        action +
        '<button class="dcpw-calculator__review" type="button" data-review-color>Review ' + escapeHTML(name) + ' bag sizes</button>' +
        '<p class="dcpw-calculator__message" data-calc-message role="status" aria-live="polite"></p>';

      var review = result.querySelector('[data-review-color]');
      if (review) review.addEventListener('click', function () { openDetail(root, card, true, true); });
      var add = result.querySelector('[data-calc-add]');
      if (add) add.addEventListener('click', function () {
        var message = result.querySelector('[data-calc-message]');
        if (!window.DcPowderBuy || typeof window.DcPowderBuy.addItems !== 'function') {
          message.textContent = 'Cart controls are still loading. Refresh and try again.';
          message.className = 'dcpw-calculator__message is-error';
          return;
        }
        var original = add.innerHTML;
        add.disabled = true;
        add.textContent = 'Adding…';
        window.DcPowderBuy.addItems(cartItems)
          .then(function () {
            add.disabled = false;
            add.innerHTML = original;
            message.textContent = 'Added the recommended raw pigment bags to cart.';
            message.className = 'dcpw-calculator__message is-success';
          })
          .catch(function (error) {
            add.disabled = false;
            add.innerHTML = original;
            message.textContent = error && error.message ? error.message : 'Could not add the recommended bags.';
            message.className = 'dcpw-calculator__message is-error';
          });
      });
    }

    color.addEventListener('change', calculate);
    dose.addEventListener('change', calculate);
    amount.addEventListener('input', calculate);
    amount.addEventListener('change', calculate);
    unit.addEventListener('change', calculate);
    calculator.querySelector('[data-project-minus]').addEventListener('click', function () {
      amount.value = Math.max(0.5, (parseFloat(amount.value) || 0.5) - 0.5);
      calculate();
    });
    calculator.querySelector('[data-project-plus]').addEventListener('click', function () {
      amount.value = (parseFloat(amount.value) || 0) + 0.5;
      calculate();
    });
    calculate();
  }

  function init(scope) {
    var root = scope && scope.querySelector ? scope.querySelector('#' + ROOT_ID) : null;
    if (!root) root = document.getElementById(ROOT_ID);
    if (!root) return;
    root.setAttribute('data-dcpw-enhanced', 'true');
    if (root.getAttribute('data-dcpw-wired') === 'true') {
      if (window.DcPowderBuy) window.DcPowderBuy.init(root);
      installCalculator(root);
      return;
    }
    root.setAttribute('data-dcpw-wired', 'true');

    root.addEventListener('click', function (event) {
      var filter = event.target.closest ? event.target.closest('[data-powder-family]') : null;
      if (filter && root.contains(filter)) {
        event.preventDefault();
        applyFamilyFilter(root, filter.getAttribute('data-powder-family'));
        return;
      }
      var close = event.target.closest ? event.target.closest('[data-powder-close]') : null;
      if (close && root.contains(close)) { event.preventDefault(); closeDetail(true); return; }
      var card = event.target.closest ? event.target.closest('#dcpowderGrid > .dcpw-card') : null;
      if (card && root.contains(card)) openDetail(root, card, true);
    });

    window.addEventListener('resize', function () {
      if (activeCard && activeDetail) placeDetail(root.querySelector('#dcpowderGrid'), activeCard, activeDetail);
    });
    applyFamilyFilter(root, 'all');
    if (window.DcPowderBuy) window.DcPowderBuy.init(root);
    installCalculator(root);
  }

  window.DcPowderPdp = { init: init, bestMatch: bestMatch, roundOne: roundOne, applyFamilyFilter: applyFamilyFilter };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();